'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(document).ready(function () {
  if ((0, _jquery2.default)('.pdp-recs').length) {
    update_rec_attributes();
  }
});

if ((0, _jquery2.default)('.pdp-recs').length) {
  var hideRecommendationsSection = function hideRecommendationsSection() {
    list.style.display = "none";
  };

  var renderProduct = function renderProduct(product) {

    var svg_add = (0, _jquery2.default)('.pdp-recs-add-svg').html();

    return ['<div class="pdp-rec">' + '<a href="' + product.url + '" class="pdp-rec-wrap">' + '<div class="plp-item-img" style="background: url(' + product.featured_image + ')"></div>' + '<div class="plp-item-info">' + '<div class="plp-item-title"">' + product.title + '</div>' + '</div>' + '</a>' + '<div class="plp-item-buy-box">' + '<div class="plp-item-price">' + Shopify.formatMoney(product.variants[0].price).replace(".00", "") + '<span class="plp-item-denomination pdp-recs-pricing-price-unit" handle="' + product.handle + '"></span>' + '</div>' + '<div class="plp-item-buy-box-actions">' + '<a href="' + product.url + '" class="plp-item-buy-box-action-options pdp-rec-option" variants="' + product.variants.length + '">Options</a>' + '<div class="plp-item-buy-box-action-add icon-add-container" data-cart-add="' + product.variants[0].id + '">' + svg_add + '</div>' + '</div>' + '</div>' + '</div>'].join("");
  };

  // Find the container that will hold the recommendations
  var list = document.querySelector(".pdp-recs");
  // Get the base URL for translated product recommendations
  var baseUrl = list.dataset.baseUrl;
  // Get the product ID to request the product recommendations
  var productId = list.dataset.productId;
  // Create an AJAX request
  var request = new XMLHttpRequest();

  request.open("GET", baseUrl + ".json?product_id=" + productId + "&limit=3");

  request.onload = function () {
    if (request.status === 404 || request.status === 422) {
      return hideRecommendationsSection();
    }

    var products = JSON.parse(request.response).products;

    if (products.length === 0) {
      return hideRecommendationsSection();
    }

    // Append product recommendations to the DOM.
    list.innerHTML = products.map(function (product) {
      return renderProduct(product);
    }).join("");
  };

  request.onerror = function () {
    hideRecommendationsSection();
  };

  // Send AJAX request
  request.send();
}

function update_rec_attributes() {
  (0, _jquery2.default)('.pdp-recs-pricing-price-unit').each(function () {
    var product_handle = (0, _jquery2.default)(this).attr('handle');
    _jquery2.default.getJSON('/products/' + product_handle + '.js', function (prod) {
      for (var i = 0, l = prod.tags.length; i < l; i++) {

        if (prod.tags[i].indexOf('Pricing:') !== -1) {
          var unit = prod.tags[i].replace('Pricing:', '');
          (0, _jquery2.default)('.pdp-recs-pricing-price-unit[handle="' + product_handle + '"]').text(unit);
        }
      }
    });
  });
}